// extracted by mini-css-extract-plugin
export default {"annotation":"Annotation-module__annotation--KlX5M","annotationSource":"Annotation-module__annotationSource--fZyli","annotationMessage":"Annotation-module__annotationMessage--gFM9M"};